module.exports = __webpack_public_path__ + "static/media/wizualizacja-99.b010941b.png";